var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('share-panel');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { CopyLinkButton } from './copy-link-button';
import { HIDE_PANEL_BUTTON_SIZE, HidePanelButton } from './hide-panel-button';
import { IconBubble } from './icon-bubble';
import { Icons } from '../icons';
import { ShareButtons } from './share-buttons';
import { useSiteMetadata } from '../../hooks/use-site-metadata';
import { useSharePanel } from '../../hooks/use-share-panel';
export var SharePanelDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", "px;\n    box-sizing: content-box;\n  "], ["\n    padding-left: ", "px;\n    box-sizing: content-box;\n  "])), HIDE_PANEL_BUTTON_SIZE)
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n    display: flex;\n    height: 140px;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n  "], ["\n    padding: ", " 0 ", ";\n    display: flex;\n    height: 140px;\n    flex-direction: row;\n    align-items: stretch;\n    justify-content: center;\n  "])), theme.UNIT(2, 2), theme.UNIT(2))
});
var BodyAndMessageStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: space-between;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    justify-content: space-between;\n  "])))
});
var SiteStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    align-items: center;\n    padding: 0 ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n    align-items: center;\n    padding: 0 ", ";\n  "])), theme.UNIT(3)),
  landscape: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.UNIT(4))
});
var PageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    border-left: 1px solid ", ";\n    padding: 0 ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    border-left: 1px solid ", ";\n    padding: 0 ", ";\n  "])), theme.COLOR('line-mid'), theme.UNIT(3)),
  landscape: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme.UNIT(4))
});
var ThumbnailStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    height: 50px;\n    position: relative;\n    top: 0px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    @media (min-width: 540px) {\n      height: 74px;\n      display: flex;\n      top: 4px;\n    }\n  "], ["\n    height: 50px;\n    position: relative;\n    top: 0px;\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    @media (min-width: 540px) {\n      height: 74px;\n      display: flex;\n      top: 4px;\n    }\n  "])), theme.UNIT(4), theme.UNIT(2)),
  landscape: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-right: ", ";\n  "], ["\n    margin-top: 0;\n    margin-bottom: 0;\n    margin-right: ", ";\n  "])), theme.UNIT(3)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    top: 0px;\n  "], ["\n    top: 0px;\n  "]))),
  desktop: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    height: 74px;\n  "], ["\n    height: 74px;\n  "])))
});
var IconBubbleStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var CommonBodyStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-grow: 1;\n  "], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-grow: 1;\n  "]))),
  tablet: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var PageBodyStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), CommonBodyStyles)
});
var PageButtonsStyles = breakpoints({
  base: css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n  "]))),
  tablet: css(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "])))
});
var SiteBodyStyles = breakpoints({
  base: css(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", ";\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    ", ";\n    flex-direction: column;\n    align-items: center;\n  "])), CommonBodyStyles),
  landscape: css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "])))
});
var SiteButtonsStyles = breakpoints({
  base: css(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SiteLinkButtonStyles = breakpoints({
  base: css(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    white-space: nowrap;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    font-family: ", ";\n    margin: 0;\n    padding-bottom: ", ";\n    text-transform: uppercase;\n  "], ["\n    white-space: nowrap;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    font-family: ", ";\n    margin: 0;\n    padding-bottom: ", ";\n    text-transform: uppercase;\n  "])), theme.FONT_SIZE(12), theme.COLOR('text-mid'), theme.FONT('sans'), theme.UNIT(0)),
  tablet: css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var PageTitleStyles = breakpoints({
  base: css(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), TitleStyles)
});
var SiteTitleStyles = breakpoints({
  base: css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), TitleStyles)
});
var MessageStyles = breakpoints({
  base: css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    margin: 4px;\n    box-sizing: border-box;\n    width: calc(100% - 8px);\n    background: #FFFFFFEE;\n    padding: ", ";\n    text-align: center;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    font-family: ", ";\n  "], ["\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    margin: 4px;\n    box-sizing: border-box;\n    width: calc(100% - 8px);\n    background: #FFFFFFEE;\n    padding: ", ";\n    text-align: center;\n    font-size: ", ";\n    font-weight: 400;\n    color: ", ";\n    font-family: ", ";\n  "])), theme.UNIT(2), theme.FONT_SIZE(12), theme.COLOR('text-mid'), theme.FONT('sans'))
});
var HideButtonStyles = breakpoints({
  base: css(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: flex;\n    height: 100%;\n  "], ["\n    position: absolute;\n    left: 0;\n    top: 0;\n    display: flex;\n    height: 100%;\n  "]))),
  desktop: css(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconBubble: styled(IconBubble)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), IconBubbleStyles),
  HideButton: styled(HidePanelButton)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), HideButtonStyles),
  BodyAndMessage: styled.div.attrs(cls.attr('body-and-message'))(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), BodyAndMessageStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Site: styled.div.attrs(cls.attr('site'))(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), SiteStyles),
  SiteTitle: styled.h2.attrs(cls.attr('site-title'))(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), SiteTitleStyles),
  SiteBody: styled.div.attrs(cls.attr('site-body'))(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), SiteBodyStyles),
  Thumbnail: styled.img.attrs(cls.attr('thumbnail'))(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), ThumbnailStyles),
  SiteButtons: styled.div.attrs(cls.attr('site-buttons'))(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), SiteButtonsStyles),
  SiteLinkButton: styled(CopyLinkButton)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), SiteLinkButtonStyles),
  Page: styled.div.attrs(cls.attr('page'))(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), PageStyles),
  PageTitle: styled.h2.attrs(cls.attr('page-title'))(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), PageTitleStyles),
  PageBody: styled.div.attrs(cls.attr('page-body'))(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), PageBodyStyles),
  PageButtons: styled(ShareButtons)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), PageButtonsStyles),
  Message: styled.div.attrs(cls.attr('message'))(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), MessageStyles)
};
export var SharePanel = function SharePanel(props) {
  var className = props.className,
      thumbnailSrc = props.thumbnailSrc;
  var site = useSiteMetadata();
  var siteUrl = site.url || site.siteUrl;
  var sharePanel = useSharePanel();

  var _a = __read(useState(false), 2),
      copied = _a[0],
      setCopied = _a[1];

  var onCopy = function onCopy() {
    return setCopied(true);
  };

  var onCopyDone = function onCopyDone() {
    return setCopied(false);
  };

  var onContainerClick = function onContainerClick(event) {
    event.stopPropagation();
  };

  var ref = sharePanel.useClickOutside();
  return React.createElement(My.Container, {
    ref: ref,
    onClick: onContainerClick,
    className: cls.name(className)
  }, React.createElement(My.HideButton, {
    label: "HIDE",
    icon: React.createElement(Icons.ShareCircle, null),
    isVertical: true,
    onClick: sharePanel.hideOnClick
  }), React.createElement(My.BodyAndMessage, null, React.createElement(My.Body, null, React.createElement(My.Site, null, React.createElement(My.PageTitle, null, "Share Report"), React.createElement(My.SiteBody, null, thumbnailSrc && React.createElement(My.Thumbnail, {
    src: thumbnailSrc
  }), React.createElement(My.SiteButtons, null, React.createElement(My.SiteLinkButton, {
    url: siteUrl,
    onCopy: onCopy,
    onCopyDone: onCopyDone,
    title: "Copy site link to clipboard"
  })))), React.createElement(My.Page, null, React.createElement(My.PageTitle, null, "Share Page"), React.createElement(My.PageBody, null, React.createElement(My.PageButtons, {
    onCopy: onCopy,
    onCopyDone: onCopyDone
  })))), copied && React.createElement(My.Message, null, "Link Copied to Clipboard")));
};
SharePanel.defaultProps = SharePanelDefaultProps;
SharePanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44;